import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { Alert, Col, Dropdown } from "react-bootstrap";

//import StudentApexLineChart from './Instructor/StudentApexLineChart';
//import UserApexLineChart from './Instructor/UserApexLineChart';
//import StudentsActivityApex from './Instructor/StudentsActivityApex';

import pic3 from "./../../../images/courses/pic3.jpg";
import pic2 from "./../../../images/courses/pic2.jpg";
import pic4 from "./../../../images/courses/pic4.jpg";
import { useDispatch, useSelector } from "react-redux";
import { getAll } from "../../../store/GetUsersSlicer";
import { Spinner } from "react-bootstrap";
import { deleteUser } from "../../../store/DeleteStudentSlicer";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import { updateUserApi } from "../../../store/UpdateUserDataSlicer";

const StudentApexLineChart = loadable(() =>
  pMinDelay(import("./Instructor/StudentApexLineChart"), 1000)
);

const studentTableBlog = [
  {
    image: pic3,
    title: "Karen Hope",
    status: "On Progress",
    changeClass: "badge-warning",
  },
  {
    image: pic2,
    title: "Jordan Nico",
    status: "No Progress",
    changeClass: "badge-primary",
  },
  {
    image: pic4,
    title: "Johnny Ahmad",
    status: "Completed",
    changeClass: "badge-success",
  },
];
function CustomDropDownBlog(props) {
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          as="a"
          className="btn-link i-false btn sharp tp-btn-light btn-dark"
        >
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.0012 9.86C11.6544 9.86 11.3109 9.92832 10.9905 10.061C10.67 10.1938 10.3789 10.3883 10.1336 10.6336C9.88835 10.8788 9.6938 11.17 9.56107 11.4905C9.42834 11.8109 9.36002 12.1544 9.36002 12.5012C9.36002 12.848 9.42834 13.1915 9.56107 13.5119C9.6938 13.8324 9.88835 14.1236 10.1336 14.3688C10.3789 14.6141 10.67 14.8086 10.9905 14.9413C11.3109 15.0741 11.6544 15.1424 12.0012 15.1424C12.7017 15.1422 13.3734 14.8638 13.8687 14.3684C14.3639 13.873 14.642 13.2011 14.6418 12.5006C14.6417 11.8001 14.3632 11.1284 13.8678 10.6332C13.3724 10.138 12.7005 9.85984 12 9.86H12.0012ZM3.60122 9.86C3.25437 9.86 2.91092 9.92832 2.59048 10.061C2.27003 10.1938 1.97887 10.3883 1.73361 10.6336C1.48835 10.8788 1.2938 11.17 1.16107 11.4905C1.02834 11.8109 0.960022 12.1544 0.960022 12.5012C0.960022 12.848 1.02834 13.1915 1.16107 13.5119C1.2938 13.8324 1.48835 14.1236 1.73361 14.3688C1.97887 14.6141 2.27003 14.8086 2.59048 14.9413C2.91092 15.0741 3.25437 15.1424 3.60122 15.1424C4.30171 15.1422 4.97345 14.8638 5.46866 14.3684C5.96387 13.873 6.24198 13.2011 6.24182 12.5006C6.24166 11.8001 5.96324 11.1284 5.46781 10.6332C4.97237 10.138 4.30051 9.85984 3.60002 9.86H3.60122ZM20.4012 9.86C20.0544 9.86 19.7109 9.92832 19.3905 10.061C19.07 10.1938 18.7789 10.3883 18.5336 10.6336C18.2884 10.8788 18.0938 11.17 17.9611 11.4905C17.8283 11.8109 17.76 12.1544 17.76 12.5012C17.76 12.848 17.8283 13.1915 17.9611 13.5119C18.0938 13.8324 18.2884 14.1236 18.5336 14.3688C18.7789 14.6141 19.07 14.8086 19.3905 14.9413C19.7109 15.0741 20.0544 15.1424 20.4012 15.1424C21.1017 15.1422 21.7734 14.8638 22.2687 14.3684C22.7639 13.873 23.042 13.2011 23.0418 12.5006C23.0417 11.8001 22.7632 11.1284 22.2678 10.6332C21.7724 10.138 21.1005 9.85984 20.4 9.86H20.4012Z"
              fill="#A098AE"
            />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className="dropdown-menu dropdown-menu-end"
          align="right"
        >
          <Dropdown.Item
            onClick={() => props.handleClick("DELETE", props.dataitem)}
          >
            Delete
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => props.handleClick("EDIT", props.dataitem)}
          >
            Edit
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
}

const InstructorStudents = () => {
  const { loading: userUpdateLoading, error: userUpdateError } = useSelector(
    (state) => state.updateUser
  );
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);

  // form controle
  const [userId, setUserId] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  // const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");

  //form errors
  const [fullNameErrorMessage, setFullNameErrorMessage] = useState("");
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  // const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setUserId("");
    setFullName("");
    setEmail("");
    // setPassword("");
    setPhone("");
    setShow(false);
  };
  const handleShow = (data) => {
    setUserId(data._id);
    setFullName(data.name);
    setEmail(data.email);
    // setPassword(data.password);
    setPhone(data.mobile);
    setShow(true);
  };

  const checkErrorMessages = () => {
    if (
      fullNameErrorMessage === "" &&
      emailErrorMessage === "" &&
      // passwordErrorMessage === "" &&
      phoneErrorMessage === ""
    ) {
      return true;
    }
    return false;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!checkErrorMessages()) {
      swal("Worrning!", "Pleace Enter Right Data", "error");
    } else {
      const formData = {
        id: userId,
        name: fullName,
        mobile: phone,
        email: email,
        role:"student"
      };
      dispatch(updateUserApi(formData)).then((res) => {
        if (res.payload.message === " User updated Successfully") {
          Swal.fire("Update Data!", res.payload.message, "success");
          handleClose();
        } else {
          Swal.fire(
            "Error!",
            `${res.payload.message}`,
            "info"
          );
        }
        dispatch(getAll("student")).then((resulet) => {
          if (resulet.payload.message === "fetched successfully") {
            setUsers(resulet.payload.data);
          }
        });
      });



    }
  };

  const { loading, error } = useSelector((state) => state.getUser);
  const [users, setUsers] = useState([]);

  const [data, setData] = useState(
    document.querySelectorAll("#student_wrapper tbody tr")
  );
  const sort = 3;
  const activePag = useRef(0);
  const [test, settest] = useState(0);

  // Active data
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#student_wrapper tbody tr"));
    //chackboxFun();
  }, [test]);

  // Active pagginarion
  activePag.current === 0 && chageData(0, sort);
  // paggination
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);

  // Active paggination & chage data
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  // hanele click
  const handleClick = (action, data) => {
    if (action === "DELETE") {
      Swal.fire({
        title: "Are you sure?",
        text: "You are going to delete this Student",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Delete it!!",
      }).then((result) => {
        if (result.isConfirmed) {
          dispatch(deleteUser(data._id)).then((res) => {
            if (res.payload.message === "deleted successfully") {
              Swal.fire("Deleted!", "User has been deleted", "success");
            } else {
              Swal.fire(
                "Error!",
                "Something bad happened ,try again later!!",
                "info"
              );
            }
            dispatch(getAll("student")).then((resulet) => {
              if (resulet.payload.message === "fetched successfully") {
                setUsers(resulet.payload.data);
              }
            });
          });
        }
      });
    } else {
      handleShow(data);
    }
  };

  useEffect(() => {
    dispatch(getAll("student")).then((resulet) => {
      if (resulet.payload.message === "fetched successfully") {
        console.log(resulet.payload.data);
        setUsers(resulet.payload.data);
      }
    });
    // dispatch(GetUsersSlicer('teacher')).
  }, []);

  return (
    <>
      <div className="row">
        {loading ? (
          <>
            <div className="row d-flex justify-content-center gap-2">
              <Spinner animation="grow" variant="warning" />
              <Spinner animation="grow" variant="warning" />
              <Spinner animation="grow" variant="warning" />
              <Spinner animation="grow" variant="warning" />
            </div>
          </>
        ) : (
          <>

          {users.length ==0 ?<>
            <div className="row d-flex text-center gap-2">
                <h3>There Is No Data</h3>
              </div>
          </>:<>
          <div className="col-xl-3 col-sm-6">
              <div className="card bg-secondary">
                <div className="card-body">
                  <div className="student-box d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                      <span className="student-icon">
                        <svg
                          width="40"
                          height="40"
                          viewBox="0 0 40 40"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.1665 19.1666C17.8331 19.1666 20.8331 16.1666 20.8331 12.4999C20.8331 8.83325 17.8331 5.83325 14.1665 5.83325C10.4998 5.83325 7.49981 8.83325 7.49981 12.4999C7.49981 16.1666 10.4998 19.1666 14.1665 19.1666ZM21.6665 17.6666C24.4998 19.9999 28.6665 19.4999 30.9998 16.6666C33.3331 13.8333 32.8331 9.66659 29.9998 7.33325C28.8331 6.33325 27.3331 5.83325 25.8331 5.83325C24.3331 5.83325 22.8331 6.33325 21.6665 7.33325C24.4998 9.66659 24.9998 13.6666 22.6665 16.6666C22.4998 16.9999 21.9998 17.3333 21.6665 17.6666ZM38.1665 32.3333C37.1665 26.1666 31.9998 21.6666 25.8331 21.6666C24.3331 21.6666 22.9998 21.8333 21.6665 22.3333C25.9998 23.8333 29.1665 27.6666 29.8331 32.1666C29.9998 32.9999 29.3331 33.9999 28.3331 33.9999H28.1665H36.4998C37.4998 33.9999 38.1665 33.3333 38.1665 32.3333C38.1665 32.4999 38.1665 32.3333 38.1665 32.3333ZM14.1665 21.6666C7.99981 21.6666 2.66647 26.1666 1.83314 32.3333C1.66647 33.1666 2.33314 34.1666 3.33314 34.1666H3.49981H24.8331C25.8331 34.1666 26.4998 33.4999 26.4998 32.4999V32.3333C25.6665 26.1666 20.3331 21.6666 14.1665 21.6666Z"
                            fill="var(--secondary)"
                          />
                        </svg>
                      </span>
                      <h4>43.322</h4>
                      <span className="pb-3 d-block">Total Students</span>
                    </div>
                    <StudentApexLineChart />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-3 col-sm-6">
              <div className="card overflow-hidden">
                <div className="card-header border-0 pb-0">
                  <h4>New Users</h4>
                </div>
                <div className="card-body pt-0">
                  <div className="student-box d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                      <h4 className="fw-normal mb-3">+12.890</h4>
                      <span className="text-secondary ">
                        <svg
                          className="me-1"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M23.25 12C23.25 5.775 18.225 0.75 12 0.75C5.775 0.749999 0.75 5.775 0.75 12C0.749999 18.225 5.775 23.25 12 23.25C18.225 23.25 23.25 18.225 23.25 12ZM11.25 16.575L11.25 9.675L9.3 11.4C8.85 11.775 8.25 11.7 7.875 11.325C7.725 11.1 7.65 10.875 7.65 10.65C7.65 10.35 7.8 10.05 8.025 9.9L11.625 6.75C11.7 6.675 11.775 6.675 11.85 6.6C11.925 6.6 11.925 6.6 12 6.525C12.075 6.525 12.075 6.525 12.15 6.525L12.225 6.525C12.3 6.525 12.3 6.525 12.375 6.525L12.45 6.525C12.525 6.525 12.525 6.525 12.6 6.6C12.6 6.6 12.675 6.6 12.675 6.675L12.75 6.75C12.75 6.75 12.75 6.75 12.825 6.825L15.975 10.05C16.35 10.425 16.35 11.1 15.975 11.475C15.6 11.85 14.925 11.85 14.55 11.475L13.125 9.975L13.125 16.65C13.125 17.175 12.675 17.7 12.075 17.7C11.7 17.55 11.25 17.1 11.25 16.575Z"
                            fill="var(--secondary)"
                          />
                        </svg>
                        +15%
                      </span>
                    </div>
                    <UserApexLineChart />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-sm-12">
              <div className="card">
                <div className="card-header border-0 pb-2 flex-wrap">
                  <h4>Students Activity</h4>
                  <div className="d-flex align-items-center">
                    <ul className="d-flex">
                      <li className="me-3">
                        <svg
                          className="me-2"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="1.5"
                            y="1.5"
                            width="9"
                            height="9"
                            rx="4.5"
                            fill="white"
                            stroke="#FEC64F"
                            strokeWidth="3"
                          ></rect>
                        </svg>
                        Last Month
                      </li>
                      <li className="ms-3">
                        <svg
                          className="me-2"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="1.5"
                            y="1.5"
                            width="9"
                            height="9"
                            rx="4.5"
                            fill="white"
                            stroke="#4CBC9A"
                            strokeWidth="3"
                          ></rect>
                        </svg>
                        Last Month
                      </li>
                    </ul>
                    <div className="d-flex align-items-center ms-5">
                      <DropDownBlog />
                    </div>
                  </div>
                </div>
                <div className="card-body pb-1 custome-tooltip pt-0 ps-0">
                  <div id="studentsActivity"></div>
                  <StudentsActivityApex />
                </div>
              </div>
            </div> */}

            <div className="col-xl-12">
              <div className="card students-list">
                <div className="card-header border-0 flex-wrap pb-0">
                  <h4>Students List</h4>
                  <div className="input-group search-area w-auto">
                    <span className="input-group-text">
                      <Link to={"#"}>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M27.414 24.586L22.337 19.509C23.386 17.928 24 16.035 24 14C24 8.486 19.514 4 14 4C8.486 4 4 8.486 4 14C4 19.514 8.486 24 14 24C16.035 24 17.928 23.386 19.509 22.337L24.586 27.414C25.366 28.195 26.634 28.195 27.414 27.414C28.195 26.633 28.195 25.367 27.414 24.586ZM7 14C7 10.14 10.14 7 14 7C17.86 7 21 10.14 21 14C21 17.86 17.86 21 14 21C10.14 21 7 17.86 7 14Z"
                            fill="var(--primary)"
                          ></path>
                        </svg>
                      </Link>
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search here..."
                    />
                  </div>
                </div>
                <div className="card-body py-0">
                  <div className="table-responsive">
                    <div
                      id="student_wrapper"
                      className="dataTables_wrapper no-footer"
                    >
                      <table
                        className="table display mb-4 dataTablesCard order-table card-table text-black application "
                        id="application-tbl1_next"
                      >
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Student ID</th>
                            <th>Email</th>
                            <th>mobile</th>
                            {/* <th>Status</th> */}
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {users &&
                            users.map((item, index) => {
                              return (
                                <>
                                  <tr key={item._id}>
                                    <td>
                                      <div className="d-flex align-items-center">
                                        <h4 className="mb-0 fs-16 font-w500">
                                          {item.name}
                                        </h4>
                                      </div>
                                    </td>
                                    <td> {item._id}</td>
                                    <td>{item.email}</td>
                                    <td>{item.mobile}</td>
                                    {/* <td><span className= {`badge  light ${item.changeClass}`}>{item.status}</span></td> */}
                                    <td>
                                      <CustomDropDownBlog
                                        handleClick={handleClick}
                                        id={item._id}
                                        dataitem={item}
                                      />
                                    </td>
                                  </tr>
                                </>
                              );
                            })}

                          {/* {studentTableBlog.map((item, index)=>(
												<tr key={index}>
													<td>
														<div className="d-flex align-items-center">
															<img src={item.image} alt="" />
															<h4 className="mb-0 fs-16 font-w500">{item.title}</h4>
															
														</div>
													</td>
													<td>1234567890</td>
													<td>UI Design Courses</td>
													<td>January 2, 2020</td>
													 <td><span className= {`badge  light ${item.changeClass}`}>{item.status}</span></td> 
													<td>
														<DropDownBlog />
													</td>
												</tr>
											))}												 */}
                        </tbody>
                      </table>
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 mb-3">
                        <div className="dataTables_info">
                          Showing {activePag.current * sort + 1} to{" "}
                          {data.length > (activePag.current + 1) * sort
                            ? (activePag.current + 1) * sort
                            : data.length}{" "}
                          of {data.length} entries
                        </div>
                        <div
                          className="dataTables_paginate paging_simple_numbers mb-0"
                          id="application-tbl1_paginate"
                        >
                          <Link
                            className="paginate_button previous "
                            to="/instructor-students"
                            onClick={() =>
                              activePag.current > 0 &&
                              onClick(activePag.current - 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-left"
                              aria-hidden="true"
                            ></i>
                          </Link>
                          <span>
                            {paggination.map((number, i) => (
                              <Link
                                key={i}
                                to="/instructor-students"
                                className={`paginate_button  ${
                                  activePag.current === i ? "current" : ""
                                } `}
                                onClick={() => onClick(i)}
                              >
                                {number}
                              </Link>
                            ))}
                          </span>

                          <Link
                            className="paginate_button next"
                            to="/instructor-students"
                            onClick={() =>
                              activePag.current + 1 < paggination.length &&
                              onClick(activePag.current + 1)
                            }
                          >
                            <i
                              className="fa fa-angle-double-right"
                              aria-hidden="true"
                            ></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>}
           
          </>
        )}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Edit User Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="form-valide" onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-xl-12">
                <div className="form-group mb-3 row">
                  <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                  >
                    Full Name
                    <span className="text-danger">*</span>
                  </label>
                  <div className="col-lg-8">
                    <input
                      required
                      type="text"
                      className="form-control"
                      id="val-username"
                      name="val-username"
                      placeholder="Enter a full name.."
                      onChange={(e) => {
                        if (
                          e.target.value.length < 3 ||
                          e.target.value.length > 50
                        ) {
                          setFullNameErrorMessage(
                            "Min 3 Characters Max 50 Characters"
                          );
                          setFullName(e.target.value);
                        } else {
                          setFullNameErrorMessage("");
                          setFullName(e.target.value);
                        }
                      }}
                      value={fullName}
                    />
                    {fullNameErrorMessage && (
                      <Alert
                        variant="warning"
                        className="alert-dismissible fade mt-1 mb-0"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="me-2"
                        >
                          <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                          <line x1="15" y1="9" x2="9" y2="15"></line>
                          <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                        <strong>Warrning </strong>
                        {fullNameErrorMessage}
                      </Alert>
                    )}
                  </div>
                </div>
                <div className="form-group mb-3 row">
                  <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-email"
                  >
                    Email <span className="text-danger">*</span>
                  </label>
                  <div className="col-lg-8">
                    <input
                      required
                      type="text"
                      className="form-control"
                      id="val-email"
                      name="val-email"
                      placeholder="Your valid email.."
                      onChange={(e) => {
                        if (e.target.value.length < 10) {
                          setEmailErrorMessage(
                            "invaild email min 10 characters"
                          );
                          setEmail(e.target.value);
                        } else {
                          setEmailErrorMessage("");
                          setEmail(e.target.value);
                        }
                      }}
                      value={email}
                    />
                    {emailErrorMessage && (
                      <Alert
                        variant="warning"
                        className="alert-dismissible fade mt-1 mb-0"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="me-2"
                        >
                          <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                          <line x1="15" y1="9" x2="9" y2="15"></line>
                          <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                        <strong>Warrning </strong>
                        {emailErrorMessage}
                      </Alert>
                    )}
                  </div>
                </div>

                {/* <div className="form-group mb-3 row">
                  <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-password"
                  >
                    Password
                    <span className="text-danger">*</span>
                  </label>
                  <div className="col-lg-8">
                    <div className="input-group transparent-append mb-2">
                      <span className="input-group-text">
                        <i className="fa fa-lock" />
                      </span>

                      <input
                        required
                        type={`${showPassword ? "text" : "password"}`}
                        className="form-control"
                        id="val-password"
                        name="password"
                        placeholder="Choose a safe one.."
                        onChange={(e) => {
                          if (e.target.value.length < 8) {
                            setPasswordErrorMessage(
                              "Password less then 8 characters"
                            );
                            setPassword(e.target.value);
                          } else {
                            setPasswordErrorMessage("");
                            setPassword(e.target.value);
                          }
                        }}
                        value={password}
                      />

                      <div
                        className="input-group-text "
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {" "}
                        {showPassword === false ? (
                          <i className="fa fa-eye-slash" />
                        ) : (
                          <i className="fa fa-eye" />
                        )}
                      </div>
                      <div
                        id="val-username1-error"
                        className="invalid-feedback animated fadeInUp"
                        style={{ display: "block" }}
                      ></div>
                    </div>
                    {passwordErrorMessage && (
                      <Alert
                        variant="warning"
                        className="alert-dismissible fade mt-1 mb-0"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="me-2"
                        >
                          <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                          <line x1="15" y1="9" x2="9" y2="15"></line>
                          <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                        <strong>Warrning </strong>
                        {passwordErrorMessage}
                      </Alert>
                    )}
                  </div>
                </div> */}

                <div className="form-group mb-3 row">
                  <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-phoneus"
                  >
                    Phone (US)
                    <span className="text-danger">*</span>
                  </label>
                  <div className="col-lg-8">
                    <input
                      maxLength={11}
                      type="text"
                      className="form-control"
                      id="val-phoneus"
                      name="val-phoneus"
                      placeholder="212-999-0000"
                      onChange={(e) => {
                        if (e.target.value[0] !== "0") {
                          setPhoneErrorMessage("Should Start With 0");
                        } else if (e.target.value[1] !== "1") {
                          setPhoneErrorMessage("Should Start With 01");
                        } else if (e.target.value.length < 11) {
                          setPhoneErrorMessage(
                            "Not Valid Egyption Number 01xxxxxxxxx"
                          );
                        } else {
                          setPhoneErrorMessage("");
                        }
                        setPhone(e.target.value);
                      }}
                      value={phone}
                    />
                    {phoneErrorMessage && (
                      <Alert
                        variant="warning"
                        className="alert-dismissible fade mt-1 mb-0"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          width="24"
                          height="24"
                          stroke="currentColor"
                          strokeWidth="2"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="me-2"
                        >
                          <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                          <line x1="15" y1="9" x2="9" y2="15"></line>
                          <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                        <strong>Warrning </strong>
                        {phoneErrorMessage}
                      </Alert>
                    )}
                  </div>
                </div>

                <div className="form-group mb-3 row  ">
                  <Col className="d-flex flex-row gap-3 justify-content-end">
                    <Button variant="secondary" onClick={handleClose}>
                      Close
                    </Button>
                    {userUpdateLoading?<>
                      <Button variant="primary" type="submit" disabled>
                      Loading......
                    </Button>
                    </>:<>
                    <Button variant="primary" type="submit" >
                      Save Changes
                    </Button>
                    </>}
                   
                  </Col>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default InstructorStudents;
